import { render } from "./CollectionOrders.html?vue&type=template&id=47860053&scoped=true"
import script from "./CollectionOrders.js?vue&type=script&lang=js"
export * from "./CollectionOrders.js?vue&type=script&lang=js"

import "./CollectionOrders.css?vue&type=style&index=0&id=47860053&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47860053"]])

export default __exports__